import { combineReducers } from '@reduxjs/toolkit';

import { reducer as contactsReducer } from 'slices/lists/contacts';
import { reducer as groupReducer } from 'slices/general/group';
import { reducer as userReducer } from 'slices/general/user';
import { reducer as miscReducer } from 'slices/misc';
import { reducer as menuReducer } from 'slices/general/menu';
import { reducer as settingsReducer } from 'slices/general/settings';
import { reducer as timetrackerReducer} from 'slices/lists/timetrackers';
import { reducer as usersReducer } from 'slices/lists/users';
import { reducer as presentationsReducer } from 'slices/lists/presentations';
import { reducer as chatMessagesReducer } from 'slices/chatMessages';
import { reducer as generalLanguagesReducer } from 'slices/general/languages';
import { reducer as customfieldsReducer } from 'slices/general/customfields';
import { reducer as permissionsReducer } from 'slices/lists/permissions';
import { reducer as groupsReducer } from 'slices/lists/groups';
import { reducer as languagesReducer } from 'slices/lists/languages';
import { reducer as rolesReducer } from 'slices/lists/roles';
import { reducer as templatesReducer } from 'slices/lists/templates';
import { reducer as notesReducer } from 'slices/lists/notes';
import { reducer as devicesReducer } from 'slices/lists/devices';
import { reducer as currentReducer } from 'slices/current';
import { reducer as filtersReducer } from 'slices/filters';
import { reducer as invoicingReducer } from 'slices/lists/invoicing';
import { reducer as ledgerAccountsReducer } from 'slices/lists/ledgerAccounts';
import { reducer as dataTransferReducer } from 'slices/dataTransfer';
import { reducer as filesReducer } from 'slices/lists/files';
import { reducer as foldersReducer } from 'slices/lists/folders';
import { reducer as appointmentReducer } from 'slices/lists/appointments';
import { reducer as projectsReducer } from 'slices/lists/projects';
import { reducer as activityReducer } from 'slices/activity';
import { reducer as tagsReducer } from 'slices/lists/tags';
import { reducer as publicwidgetsReducer } from 'slices/lists/publicwidgets';
import { reducer as globalActivityReducer } from 'slices/lists/globalActivity';
import { reducer as archivesReducer } from 'slices/archives';
import { reducer as systemSettingsReducer } from 'slices/lists/systemSettings';
import { reducer as productsReducer } from 'slices/lists/products';
import { reducer as servicesReducer } from 'slices/lists/services';
import { reducer as topbarReducer } from 'slices/topbar';
import { reducer as registerReducer } from 'slices/register';
import { reducer as workingHoursReducer } from 'slices/lists/workingHours';
import { reducer as holidaysReducer } from 'slices/lists/holidays';
import { reducer as absencesReducer } from 'slices/lists/absences';
import { reducer as formsReducer } from 'slices/forms';
import { reducer as messageTemplatesReducer } from 'slices/lists/messageTemplates';
import { reducer as giftcardsReducer } from 'slices/lists/giftcards';
import { reducer as eventsReducer } from 'slices/lists/events';
import { reducer as messagesReducer } from 'slices/lists/messages';
import { reducer as eventProjectsReducer } from 'slices/lists/eventProjects';

const generalReducer = combineReducers({
  menu: menuReducer,
  user: userReducer,
  customfields: customfieldsReducer,
  group: groupReducer,
  languages: generalLanguagesReducer,
  settings: settingsReducer
});

const listReducer = combineReducers({
  contacts: contactsReducer,
  users: usersReducer,
  permissions: permissionsReducer,
  groups: groupsReducer,
  languages: languagesReducer,
  roles: rolesReducer,
  templates: templatesReducer,
  invoicing: invoicingReducer,
  notes: notesReducer,
  ledger_accounts: ledgerAccountsReducer,
  products: productsReducer,
  services: servicesReducer,
  time_trackers: timetrackerReducer,
  presentations: presentationsReducer,
  devices: devicesReducer,
  files: filesReducer,
  folders: foldersReducer,
  appointments: appointmentReducer,
  projects: projectsReducer,
  tags: tagsReducer,
  public_widgets: publicwidgetsReducer,
  global_activity: globalActivityReducer,
  systemSettings: systemSettingsReducer,
  workingHours: workingHoursReducer,
  holidays: holidaysReducer,
  absences: absencesReducer,
  messageTemplates: messageTemplatesReducer,
  giftcards: giftcardsReducer,
  events: eventsReducer,
  messages: messagesReducer,
  eventProjects: eventProjectsReducer 
});

const rootReducer = combineReducers({
  general: generalReducer,
  lists: listReducer,
  current: currentReducer,
  chatMessages: chatMessagesReducer,
  misc: miscReducer,
  filters: filtersReducer,
  dataTransfer: dataTransferReducer,
  activity: activityReducer,
  archives: archivesReducer,
  topbar: topbarReducer,
  register: registerReducer,
  forms: formsReducer
});

export default rootReducer;
